import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      width="20px"
      height="18px"
      viewBox="0 0 20 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        d="M0,16.9846154 L0,5.07692309 C0,4.80000001 0.140845073,4.24615387 0.42253522,3.96923076 C0.845070439,3.4153846 1.40845071,3.13846154 1.97183098,3 L18.028169,3 C19.1549296,3.13846154 20,4.1076923 20,5.49230769 L20,16.7076923 C20,18.2307692 19.0140845,19.2 17.4647887,19.2 L13.3802817,19.2 C12.8169014,19.2 12.3943662,19.3384615 11.8309859,19.6153846 C11.1267606,20.1692308 10.4225352,20.5846154 9.71830985,21 L7.18309859,19.3384615 C7.04225351,19.2 6.76056337,19.2 6.61971832,19.2 L1.97183098,19.2 C1.12676056,19.2 0.422535195,18.9230769 0,18.2307692 C0.140845073,17.9538461 0.140845073,17.4 0,16.9846154 Z M10.8450704,13.8 L10.8450704,13.6615385 C10.7042253,12.8307692 11.1267606,12.2769231 11.6901409,11.8615385 C12.1126761,11.4461538 12.5352113,11.0307692 12.8169014,10.6153846 C14.084507,9.36923077 13.8028169,7.43076924 12.3943662,6.46153845 C11.4084507,5.63076923 10.1408451,5.63076923 9.01408451,5.76923077 C7.6056338,6.04615386 6.61971832,7.15384616 6.47887324,8.53846155 C6.47887324,8.67692309 6.47887324,8.95384617 6.61971832,9.09230769 C7.04225354,9.36923077 7.46478873,9.36923077 7.88732395,9.23076923 C8.1690141,9.23076923 8.30985917,8.95384614 8.30985915,8.67692309 C8.59154929,7.84615386 9.01408449,7.2923077 10,7.15384616 C11.1267606,7.01538462 12.112676,7.98461538 11.8309859,8.95384614 C11.6901409,9.23076923 11.4084507,9.50769231 11.1267606,9.78461539 C10.7042253,10.2 10.1408451,10.6153846 9.71830985,11.1692308 C9.01408451,12 9.01408451,12.9692308 9.01408451,13.8 L10.8450704,13.8 Z M10.9859155,16.4307692 C10.9859155,15.8769231 10.5633803,15.4615385 10,15.4615385 C9.43661971,15.4615385 9.15492959,15.8769231 9.15492959,16.4307692 C9.15492959,16.9846154 9.57746481,17.4 10.1408451,17.4 C10.5633803,17.4 10.9859155,16.9846154 10.9859155,16.4307692 Z"
        id="形状"
      />
    </svg>
  )
}
const HelpIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
HelpIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#fff',
}
// 参数类型
HelpIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default HelpIcon
